import React, { useMemo, memo, useState } from "react";
import { useTable } from "react-table";
import { SUB_COLUMNS } from "./utils";

const SubReportTable = ({ row, setMain, mainData }) => {
  const [data, setData] = useState(row.original.toWarehouses);
  // const [originalData] = useState(data);
  // const [skipPageReset, setSkipPageReset] = useState(false);

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page

    const newData = [...mainData];
    const index = newData.findIndex(
      (e) => e.productId === row.original.productId
    );

    // setSkipPageReset(true);
    setData((old) => {
      const update = old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value ? Number(value) : 0,
          };
        }
        return row;
      });

      if (index !== -1) {
        newData[index].toWarehouses = update;
        setMain(newData);
      }

      return update;
    });
  };

  // After data chagnes, we turn the flag back off
  // so that if data actually changes when we're not
  // editing it, the page is reset
  // useEffect(() => {
  //   setSkipPageReset(false);
  // }, [data]);

  const columns = useMemo(() => SUB_COLUMNS, []);
  //   const data = useMemo(() => row.original.toWarehouses, [row]);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
      updateMyData,
    });

  return (
    <React.Fragment>
      <table
        {...getTableProps()}
        className="table sub-table table-bordered table-striped"
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default memo(SubReportTable);
